import type { StoryChoices, Story } from './types';

const API_BASE = '/api';

export async function createCheckoutSession(
  choices: StoryChoices
): Promise<{ sessionId: string; url: string }> {
  const successUrl = `${window.location.origin}/success?session_id={CHECKOUT_SESSION_ID}`;
  const cancelUrl = `${window.location.origin}/create`;

  const response = await fetch(`${API_BASE}/checkout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      choices,
      successUrl,
      cancelUrl,
    }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Failed to start checkout' }));
    throw new Error(error.message || 'Failed to start checkout');
  }

  return response.json();
}

export async function generateStory(choices: StoryChoices): Promise<Story> {
  const response = await fetch(`${API_BASE}/generate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(choices),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Failed to generate story' }));
    throw new Error(error.message || 'Failed to generate story');
  }

  return response.json();
}

export async function getSharedStory(id: string): Promise<Story> {
  const response = await fetch(`${API_BASE}/stories/${id}`);

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Story not found');
    }
    throw new Error('Failed to load story');
  }

  return response.json();
}

export async function shareStory(story: Story): Promise<string> {
  const response = await fetch(`${API_BASE}/stories`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(story),
  });

  if (!response.ok) {
    throw new Error('Failed to share story');
  }

  const { id } = await response.json();
  return id;
}
